import { Trans } from 'react-i18next';

const PRIVACY_POLICY_URL =
  'https://app.privasee.io/privacy-portal/64ac2c059f43880013f2faf0';

export default function TermsNotice() {
  return (
    <p className="w-full text-center font-body text-xs leading-5 text-grey-hide">
      <Trans
        i18nKey="login.termsNotice"
        components={{
          privacy: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans fills the link text from the translation
            <a
              className="underline"
              href={PRIVACY_POLICY_URL}
              rel="noopener noreferrer"
              target="_blank"
            />
          ),
          terms: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans fills the link text from the translation
            <a className="underline" href="/terms-and-conditions/" />
          )
        }}
      />
    </p>
  );
}
